var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sub-page',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"description":_vm.description,"button-text":_vm.buttonText,"bg":_vm.bg,"right-bg":_vm.rightBg,"partition":[8, 4],"bottom":"-100px","direction":"flex-end","rbgStyle":{ width: '80%' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }